// Three-state read of a locked estimate's override quality — mirrors
// sp_GetSyncOverridesDigestEmail's WHERE clause (db/96_sync_overrides_digest.sql)
// exactly, so the dashboard badge and the weekly digest never disagree about
// which bucket a row is in. See db/82_estimate_milestones.sql's
// HubSpotStatusAtLock/LastSeenHubSpotStatus comment for the full rationale.
//
//   'stale'         LastSeenHubSpotStatus is unset, or unchanged from
//                    HubSpotStatusAtLock, and still != Status — genuinely
//                    still waiting on Sales. Only this bucket is emailed.
//   'resolved'      LastSeenHubSpotStatus now equals Status — HubSpot caught
//                    up to the estimator's correction. Safe to unlock.
//   'needs_review'  LastSeenHubSpotStatus changed since lock but doesn't
//                    match Status — HubSpot moved to something nobody
//                    predicted. Needs a person, not sales pressure.
export function deriveOverrideState({ Status, HubSpotStatusAtLock, LastSeenHubSpotStatus }) {
  if (LastSeenHubSpotStatus == null) return "stale";
  if (LastSeenHubSpotStatus === Status) return "resolved";
  if (LastSeenHubSpotStatus !== HubSpotStatusAtLock) return "needs_review";
  return "stale";
}
